import { createFeature, createReducer, on } from '@ngrx/store';
import { Step } from '@qtek/shared/models';
import { WizardActions } from './wizard.actions';

export interface WizardState {
  steps: Step[];
  maxPersonProgress: number | null;
  maxCompanyProgress: number | null;
  isWizardLoading: boolean;
  wizardDone: boolean;
}

const initialState: WizardState = {
  steps: [],
  isWizardLoading: false,
  maxPersonProgress: null,
  maxCompanyProgress: null,
  wizardDone: false,
};

export const WizardReducer = createReducer(
  initialState,
  on(WizardActions.isWizardDone, state => ({
    ...state,
    wizardDone: true,
  })),
  on(WizardActions.getStepsSuccess, (state, { payload }) => ({
    ...state,
    steps: payload,
  })),
  on(WizardActions.setMaxPersonProgress, (state, { payload }) => ({
    ...state,
    maxPersonProgress: payload,
  })),
  on(WizardActions.setMaxCompanyProgress, (state, { payload }) => ({
    ...state,
    maxCompanyProgress: payload,
  })),
  on(WizardActions.setLoading, (state, { payload }) => ({
    ...state,
    isWizardLoading: payload,
  }))
);

export const wizardFeature = createFeature({
  name: 'wizard',
  reducer: WizardReducer,
});

export const {
  selectWizardDone,
  selectSteps,
  selectMaxPersonProgress,
  selectMaxCompanyProgress,
  selectIsWizardLoading,
} = wizardFeature;
